import { render, staticRenderFns } from "./boardOneItem.vue?vue&type=template&id=fd5a0484&scoped=true"
import script from "./boardOneItem.vue?vue&type=script&lang=js"
export * from "./boardOneItem.vue?vue&type=script&lang=js"
import style0 from "./boardOneItem.vue?vue&type=style&index=0&id=fd5a0484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5a0484",
  null
  
)

export default component.exports